<template>
  <teleport to="body">
    <transition name="modal">
      <div v-if="isOpen">
        <div class="modal-wrapper" :style="{width: setWidth, height: setHeight, zIndex: (zIndex) ? zIndex : 1001}">
          <div class="modal-header">
            <div class="modal-title">{{ title }}</div>
            <span class="modal-close" v-if="closeButton" @click="close"><i class="fa-solid fa-xmark"></i></span>
          </div>
          <div class="modal-body">
            <slot></slot>
          </div>
        </div>
        <div class="modal-overlay" @click="outSideClick" v-if="overlay !== false"></div>
      </div>
    </transition>
  </teleport>
</template>

<script lang="ts">
import { defineComponent, computed, ref } from 'vue'

export default defineComponent({
  props: {
    useModal: {},
    title: {
      type: String
    },
    zIndex: {
      type: Number
    },
    overlay: {
      type: Boolean,
      default: true
    },
    closeButton: {
      type: Boolean,
      default: false
    },
    outSideClickclose: {
      type: Boolean,
      default: false
    },
    width: {
      type: String
    },
    height: {
      type: String
    },
  },
  setup(props) {
    const isOpen = ref(false)

    const open = () => {
      document.body.classList.add('modal-open')
      isOpen.value = true
    }

    const close = () => {
      isOpen.value = false
      document.body.classList.remove('modal-open')
    }

    const outSideClick = () => {
      if (props.outSideClickclose) {
        close()
      }
    }
    const setWidth = computed(() => {
      return props.width ? props.width : 'auto'
    })

    const setHeight = computed(() => {
      return props.height ? props.height : 'auto'
    })

    return {
      isOpen,
      open,
      close,
      setWidth,
      setHeight,
      outSideClick,
    }
  },
})
</script>

<style lang="scss" scoped>
@import '@scss/components/modal.scss';
</style>

<style>
body.modal-open {
  overflow-y: hidden;
}
</style>